import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { Banner, BannerUpsertPayload } from '../models/banner.model';

@Injectable({ providedIn: 'root' })
export class BannersApi {
  private readonly http = inject(HttpClient);
  private readonly endpoint = `${environment.urlApi}api/banners`;
  getAll(): Observable<Banner[]> {
    return this.http.get<Banner[]>(this.endpoint);
  }
  getActive(areaId: string | null): Observable<Banner[]> {
    let params = new HttpParams();
    if (areaId) params = params.set('areaId', areaId);
    return this.http.get<Banner[]>(`${this.endpoint}/active`, { params });
  }
  getById(id: string): Observable<Banner> {
    return this.http.get<Banner>(`${this.endpoint}/${id}`);
  }
  create(payload: BannerUpsertPayload): Observable<{ id: string }> {
    return this.http.post<{ id: string }>(this.endpoint, payload);
  }
  update(id: string, payload: BannerUpsertPayload): Observable<void> {
    return this.http.put<void>(`${this.endpoint}/${id}`, payload);
  }
  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.endpoint}/${id}`);
  }
}
